import { Component, OnInit, inject } from '@angular/core';
import {
  Event,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router
} from '@angular/router';
import { TslSessionService } from 'projects/aztalena-core/src/public-api';
import { WebForum } from 'src/app/forum/web-forum';
import { ForumService } from '../../forum/forum.service';
import { UserInfo } from '../../user-info';
import { UserService } from '../../user/user.service';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss'],
  standalone: false
})
export class NavComponent implements OnInit {
  private router = inject(Router);
  private session = inject(TslSessionService);
  private forumService = inject(ForumService);
  private userService = inject(UserService);

  forums: WebForum[];
  isLoading = false;

  currentUser: UserInfo;

  ngOnInit(): void {
    this.getForums();
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        this.isLoading = true;
      } else if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        setTimeout(() => (this.isLoading = false), 0);
      }
    });
    this.userService.getCurrentUser().subscribe((currentUser) => (this.currentUser = currentUser));
  }

  signOut(): void {
    this.session.destroy();
    location.reload();
  }

  signIn(): void {
    this.router.navigate(['sign-in'], {
      queryParams: { returnUrl: this.currentPath }
    });
  }

  get isSignedIn(): boolean {
    return this.session.isSignedIn;
  }

  get currentPath(): string {
    return this.router.routerState.snapshot.url;
  }

  private getForums(): void {
    this.forumService.getForums().subscribe((forums) => {
      this.forums = forums;
    });
  }
}
